import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';
import 'current-script-polyfill';
import 'reflect-metadata';
import 'url-search-params-polyfill';

import { bootstrap } from './framework/bootstrap';

bootstrap();



// WEBPACK FOOTER //
// ./src/index.prod.tsx